import React from 'react'
import {
    Button,
    FormControl,
    IconButton,
    Input,
    InputLabel,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputAdornment from "@mui/material/InputAdornment";
import { useResetPassword } from '../../Hooks/Auth/useResetPassword';

const ResetForm = ({ flag }) => {
    const { resetPasswordData, handleChange, showPassword, setShowPassword, HandleResetPassword, error } = useResetPassword();

    return (
        <div>
            <form className="login-section" onSubmit={HandleResetPassword} style={{ width: "100%" }}>
                <div className="login-input">
                    <FormControl variant="standard" style={{ width: "100%" }} className='mx-0'>
                        <InputLabel>{flag ? "Old Password" : "Temporary Password"}</InputLabel>
                        <Input
                            value={resetPasswordData.old_password}
                            onChange={handleChange}
                            type={showPassword?.old_password ? "text" : "password"}
                            variant="standard"
                            size="small"
                            name="old_password"
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowPassword({ ...showPassword, "old_password": !showPassword?.old_password })}
                                    >
                                        {showPassword?.old_password ? (
                                            <FontAwesomeIcon icon="fa-solid fa-eye-slash" />
                                        ) : (
                                            <FontAwesomeIcon icon="fa-solid fa-eye" />
                                        )}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        <p className='text-danger text-left'>{error?.old_password}</p>
                    </FormControl>
                    <FormControl variant="standard" style={{ width: "100%" }} className='mx-0'>
                        <InputLabel>New Password</InputLabel>
                        <Input
                            value={resetPasswordData?.new_password}
                            onChange={handleChange}
                            type={showPassword?.new_password ? "text" : "password"}
                            variant="standard"
                            size="small"
                            name="new_password"
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowPassword({ ...showPassword, "new_password": !showPassword?.new_password })}
                                    >
                                        {showPassword?.new_password ? (
                                            <FontAwesomeIcon icon="fa-solid fa-eye-slash" />
                                        ) : (
                                            <FontAwesomeIcon icon="fa-solid fa-eye" />
                                        )}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        <p className='text-danger text-left'>{error?.new_password}</p>
                    </FormControl>
                    <FormControl variant="standard" style={{ width: "100%" }} className='mx-0'>
                        <InputLabel htmlFor="login-password">Confirm Password</InputLabel>
                        <Input
                            value={resetPasswordData?.conform_password}
                            onChange={handleChange}
                            type={showPassword?.conform_password ? "text" : "password"}
                            variant="standard"
                            size="small"
                            name="conform_password"
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={() => setShowPassword({ ...showPassword, "conform_password": !showPassword?.conform_password })}
                                    >
                                        {showPassword?.conform_password ? (
                                            <FontAwesomeIcon icon="fa-solid fa-eye-slash" />
                                        ) : (
                                            <FontAwesomeIcon icon="fa-solid fa-eye" />
                                        )}
                                    </IconButton>
                                </InputAdornment>
                            }
                        />
                        <p className='text-danger text-left'>{error?.conform_password}</p>
                    </FormControl>
                </div>
                <Button
                    type="submit"
                    variant="contained"
                    className="login-button"
                >
                    Reset <FontAwesomeIcon icon="fa-solid fa-arrow-right btn-icon" />
                </Button>
                {error?.apiError && <p className='text-danger text-center font-weight-bold' >{error?.apiError}</p>}
            </form>
        </div>
    )
}

export default ResetForm
